<template lang="pug">
    v-speed-dial(
        v-model="fab"
        hover
        direction="left"
        transition="slide-x-reverse-transition"
    )
        template(v-slot:activator="")
            v-btn(
                v-model="fab"
                icon
            )
                v-icon(v-if="!fab" color="white") open_in_new
                v-icon(v-else color="white") close

        share-network(
            v-if="isMindfulMoment ? isGoldman : true"
            network="Email"
            :url="url"
            :title="isMindfulMoment ? item.emailSubject : item.title"
            :description="item.description"
        )
            v-btn.shareButton(
                icon
                color="action"
            )
                v-icon(color="white") mail

        share-network(
            network="WhatsApp"
            :url="url"
            :title="isMindfulMoment ? item.emailSubject : item.title"
            :description="item.description"
        )
            v-btn.shareButton(
                icon
                color="white"
            )
                img(:src="whatsappIcon")

        share-network(
            network="facebook"
            :url="url"
            :title="item.title"
            :description="item.description"
            :hashtags="item.tags"
            :media="item.poster"
            :quote="quote"
        )
            v-btn.shareButton(
                icon
                color="white"
            )
                img(:src="facebookIcon")

        share-network(
            network="Twitter"
            :url="url"
            :title="item.title"
            :hashtags="item.tags"
        )
            v-btn.shareButton(
                icon
                color="white"
            )
                img(:src="twitterIcon")

</template>

<script>
    import VueTypes from 'vue-types';
    import facebookIcon from './icons/facebook.svg';
    import twitterIcon from './icons/twitter.svg';
    import whatsappIcon from './icons/whatsapp.svg';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            item: VueTypes.object.def({}),
            callbackFunction: VueTypes.func.def(() => {}),
            isMindfulMoment: VueTypes.bool.def(false)
        },
        data() {
            return {
                facebookIcon,
                twitterIcon,
                whatsappIcon,
                fab: false
            };
        },
        computed: {
            url() {
                if (this.isMindfulMoment)
                    return `${process.env.VUE_APP_HOST}/mindful-moments`;
                return `${process.env.VUE_APP_HOST}/sessions/view/${this.item.id}`;
            },
            quote() {
                if (this.item && this.item.instructor)
                    return `${this.item.title} with ${this.item.instructor.fullName}`;
                return `${this.item.title}`;
            },
            ...mapGetters('auth', ['user', 'isGoldman'])
        },
        watch: {
            fab(val, oldVal) {
                if (val === oldVal) return;
                this.callbackFunction(val);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"

    >>> .v-btn--icon
        width: 28px
        height: 28px
        opacity: 0.95

        .v-icon
            font-size: 18px
</style>
